const STORAGE_RESET_KEY = 'app_storage_reset_version';

// Bump ONLY when a release must discard all client-side storage — i.e. a
// persisted-state format change that cannot be expressed through its own
// versioning (REACT_QUERY_PERSIST_BUSTER covers the react-query cache).
//
// This must NOT be tied to the build hash: wiping on every release also
// deleted Cache Storage, and with it the service worker's precache — the very
// thing that lets a long-lived tab keep loading its own (old) chunks after a
// deploy removes them from the server. That wipe was the main cause of
// "Failed to fetch dynamically imported module" after releases. Cache Storage
// and IndexedDB belong to the service worker / libraries and must never be
// cleared here.
export const STORAGE_RESET_VERSION = '1';

export function clearStaleStorage() {
  if (localStorage.getItem(STORAGE_RESET_KEY) === STORAGE_RESET_VERSION) return;

  localStorage.clear();
  sessionStorage.clear();

  localStorage.setItem(STORAGE_RESET_KEY, STORAGE_RESET_VERSION);
}
